'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//------------------------------------------------------------------------------
//
//  Modules
//
//------------------------------------------------------------------------------

var _ = require('lodash');

//------------------------------------------------------------------------------
//
//  Functions
//
//------------------------------------------------------------------------------

//--------------------------------------
//  DOM 操作ヘルパー（要素の検索、抽出）
//--------------------------------------

/**
 * 親の DOM から、指定したタグ名の子要素を探します。（複数ある場合は最初の要素を返す）
 *
 * @param {Object} dom - 親の DOM（htmlparser2 の DOM オブジェクト）
 * @param {string} tagName - 探したい DOM のタグ名
 * @return {Object} htmlparser2 の DOM オブジェクト
 * @private
 */
function findChildDomByTag(dom, tagName) {
  var targetDom = _.find(dom.children, function (childDom) {
    return childDom.type === 'tag' && childDom.name === tagName;
  });

  if (_.isNil(targetDom) && !_.isEmpty(dom.children)) {
    _.each(dom.children, function (childDom) {
      if (_.isNil(targetDom)) {
        targetDom = findChildDomByTag(childDom, tagName);
      }
    });
  }

  return targetDom;
}

/**
 * 親の DOM から、指定したタグ名の子要素を全て探します。
 *
 * @param {Object} dom - 親の DOM（htmlparser2 の DOM オブジェクト）
 * @param {string} tagName - 探したい DOM のタグ名
 * @return {Array.<Object>} DOM の配列（htmlparser2 の DOM オブジェクト）
 * @private
 */
function findChildDomsByTag(dom, tagName) {
  var targetDoms = _.filter(dom.children, function (childDom) {
    return childDom.type === 'tag' && childDom.name === tagName;
  });

  if (_.isEmpty(targetDoms) && !_.isEmpty(dom.children)) {
    _.each(dom.children, function (childDom) {
      if (_.isEmpty(targetDoms)) {
        targetDoms = findChildDomsByTag(childDom, tagName);
      }
    });
  }

  return targetDoms;
}

/**
 * DOM 要素からテキストだけを抽出します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {string}
 * @private
 */
function getText(dom) {
  var textData = '';

  if (dom.type === 'text') {
    textData = dom.data;
  } else if (!_.isEmpty(dom.children)) {
    _.each(dom.children, function (childDom) {
      textData += getText(childDom);
    });
  }

  return textData;
}

//--------------------------------------
//  DOM 操作ヘルパー（ブロック要素の判別）
//--------------------------------------
/**
 * Determines whether it is table
 *
 * The corresponding table is the `<table>` tag with the class name `trill-article-table`
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isTable(dom) {
  return dom.type === 'tag' && dom.name === 'table' && dom.attribs.class === 'trill-article-table';
}

/**
 * Determines whether it is an article internal link
 *
 * The corresponding article internal link is the `<div>` tag with the class name `article-internal-link`
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isArticleInternalLink(dom) {
  return dom.type === 'tag' && dom.name === 'div' && /(article-internal-link)/.test(dom.attribs.class);
}

/**
 * 見出しどうかを判別します。
 *
 * 横ラインのタグ `<hr>` も含め見出し要素として判定します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isHeading(dom) {
  return dom.type === 'tag' && /^(h[1-6]{1}|hr)$/.test(dom.name);
}

/**
 * 段落かどうかを判別します。
 *
 * 対応する段落タグは `<p>` のみです。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isParagraph(dom) {
  if (dom.type === 'tag' && /^p$/.test(dom.name)) {
    var image = findChildDomByTag(dom, 'img');
    var iframe = findChildDomByTag(dom, 'iframe');
    var link = findChildDomByTag(dom, 'a');
    var isSponsoredLink = !_.isNil(link) && /(^|\s)button(\s|$)/.test(link.attribs.class) && /(^|\s)button--block(\s|$)/.test(link.attribs.class);

    if (!_.isNil(image) || !_.isNil(iframe) || isSponsoredLink) {
      return false;
    }

    return true;
  }

  return false;
}

/**
 * リストかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isList(dom) {
  return dom.type === 'tag' && /^(ul|ol)$/.test(dom.name);
}

/**
 * 引用かどうかを判別します。
 *
 * 対応する引用タグは `<blockquote>` のみです。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isQuotation(dom) {
  if (dom.type === 'tag' && dom.name === 'blockquote') {
    if (/(twitter-tweet|instagram-media|text-post-media|tiktok-embed|reddit-card|reddit-embed-bq)/.test(dom.attribs.class)) {
      return false;
    }

    return true;
  }

  return false;
}

/**
 * 画像かどうかを判別します。
 *
 * `<figure>` で囲まれている必要があります。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isImageBlock(dom) {
  if (dom.type === 'tag' && (dom.name === 'figure' || dom.name === 'p')) {
    var image = findChildDomByTag(dom, 'img');

    if (!_.isNil(image)) {
      return true;
    }
  }

  return false;
}

/**
 * 動画かどうかを判別します。
 *
 * `<figure>` で囲まれている必要があります。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isVideoBlock(dom) {
  if (dom.type === 'tag' && dom.name === 'figure') {
    var video = findChildDomByTag(dom, 'video');

    if (!_.isNil(video)) {
      return true;
    }
  }

  return false;
}

/**
 * YouTube 埋め込み動画かどうかを判別します。
 *
 * `<iframe>` 形式のみ対応します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isYouTubeEmbed(dom) {
  if (dom.type === 'tag' && (dom.name === 'iframe' || dom.name === 'p')) {
    var iframe = dom.name === 'iframe' ? dom : findChildDomByTag(dom, 'iframe');

    if (_.isNil(iframe)) {
      return false;
    }

    // YouTube 埋め込み動画かを確認
    return (/^((http|https):)?\/\/www\.youtube\.com\/embed\/([^?]+)(\?.+)?/.test(iframe.attribs.src)
    );
  }

  return false;
}

function isCgmContentEmbed(dom) {
  if (dom.type === 'tag' && (dom.name === 'iframe' || dom.name === 'p')) {
    var iframe = dom.name === 'iframe' ? dom : findChildDomByTag(dom, 'iframe');

    if (_.isNil(iframe)) {
      return false;
    }

    return (/^https:\/\/trilltrill(-dev|-stg)?\.jp\/(shorts|cards)\/([^?]+)(\?.+)?/.test(iframe.attribs.src)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Twitter 埋め込みツイート）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isTwitterTweetEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'blockquote' && dom.attribs.class === 'twitter-tweet') {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');

  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var _ref = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/) || [],
        _ref2 = _slicedToArray(_ref, 2),
        embedCode = _ref2[1];

    // 埋め込みタグの中に twitter-tweet の文字列がある場合は Twitter の埋め込み


    return (/twitter-tweet/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Twitter 埋め込みツイート）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isTwitterTweetEmbedScript(dom) {
  return dom.type === 'script' && /^((http|https):)?\/\/platform\.twitter\.com\/widgets\.js/.test(dom.attribs.src);
}

/**
 * SNS 投稿の埋め込み（Facebook 埋め込み投稿）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isFacebookEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'div' && /(fb-root|fb-post|fb-video)/.test(dom.attribs.class) || dom.type === 'tag' && dom.name === 'iframe' && /^https:\/\/www\.facebook\.com\/plugins\/(post|video)\.php\?/.test(dom.attribs.src)) {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');
  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var iframeDomSrc = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src', '');
    if (iframeDomSrc.match(/^https:\/\/www\.facebook\.com\/plugins\/(post|video)\.php\?/)) {
      return true;
    }

    var _ref3 = iframeDomSrc.match(/^javascript:\s?'(.[\s\S]*)?'$/) || [],
        _ref4 = _slicedToArray(_ref3, 2),
        embedCode = _ref4[1];

    // 埋め込みタグの中に (fb-root|fb-post|fb-video) の文字列がある場合は Facebook の埋め込み


    return (/(fb-root|fb-post|fb-video)/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Facebook 埋め込み投稿）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isFacebookEmbedScript(dom) {
  return dom.type === 'tag' && dom.name === 'div' && dom.attribs.id === 'fb-root' || dom.type === 'script' && /\/\/connect\.facebook\.net\/[\w_]+\/sdk\.js/.test(getText(dom));
}

/**
 * SNS 投稿の埋め込み（Instagram）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isInstagramEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'blockquote' && dom.attribs.class === 'instagram-media') {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');

  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var _ref5 = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'$/) || [],
        _ref6 = _slicedToArray(_ref5, 2),
        embedCode = _ref6[1];
    // 埋め込みタグの中に instagram-media の文字列がある場合は Instagram の埋め込み


    return (/instagram-media/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Instagram）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isInstagramEmbedScript(dom) {
  return dom.type === 'script' && (/^((http|https):)?\/\/platform\.instagram\.com\/[\w_]+\/embeds\.js$/.test(dom.attribs.src) || /^((http|https):)?\/\/www\.instagram\.com\/embed\.js$/.test(dom.attribs.src));
}

/**
 * SNS 投稿の埋め込み（Thread）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isThreadEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'blockquote' && dom.attribs.class === 'text-post-media') {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');

  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var _ref7 = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'$/) || [],
        _ref8 = _slicedToArray(_ref7, 2),
        embedCode = _ref8[1];
    // 埋め込みタグの中に text-post-media の文字列がある場合は Thread の埋め込み


    return (/text-post-media/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Thread）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isThreadEmbedScript(dom) {
  return dom.type === 'script' && /^((http|https):)?\/\/www\.threads\.(net|com)\/embed\.js$/.test(dom.attribs.src);
}

/**
 * SNS 投稿の埋め込み（Pinterest）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isPinterestEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'a' && /^embed(Pin|Board|User)$/.test(dom.attribs['data-pin-do'])) {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');

  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var _ref9 = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/) || [],
        _ref10 = _slicedToArray(_ref9, 2),
        embedCode = _ref10[1];

    // 埋め込みタグの中に data-pin-do の文字列がある場合は Twitter の埋め込み


    return (/data-pin-do/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Pinterest）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isPinterestEmbedScript(dom) {
  return dom.type === 'script' && /^\/\/assets\.pinterest\.com\/[\w]+\/pinit\.js$/.test(dom.attribs.src);
}

/**
 * ボタン（ブロック）かどうかを判別します。
 *
 * @param {*} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isBlockButton(dom) {
  if (dom.type === 'tag' && (dom.name === 'a' || dom.name === 'button' || dom.name === 'p')) {
    var blockButton = dom.name === 'p' ? findChildDomByTag(dom, 'a') : dom;

    if (_.isNil(blockButton)) {
      return false;
    }

    return (/(^|\s)button(\s|$)/.test(blockButton.attribs.class) && /(^|\s)button--block(\s|$)/.test(blockButton.attribs.class)
    );
  }

  return false;
}

//--------------------------------------
//  DOM 操作ヘルパー（インライン要素の判別）
//--------------------------------------

/**
 * テキストかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isText(dom) {
  return dom.type === 'text';
}

/**
 * 改行かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isLineBreak(dom) {
  return dom.type === 'tag' && dom.name === 'br';
}

/**
 * 書式かどうかを判別します。
 *
 * 対応する書式は以下のみです。
 * - `<b>`: 太字
 * - `<strong>`: 重要なテキスト（太字）
 * - `<i>`: 斜体
 * - `<em>`: 強調テキスト（斜体）
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isFormatting(dom) {
  return dom.type === 'tag' && /^(b|strong|i|em)$/.test(dom.name);
}

/**
 * リンクかどうかを判別します。
 *
 * `target` 属性は無視されます。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isLink(dom) {
  return dom.type === 'tag' && dom.name === 'a' && !_.isNil(dom.attribs.href) && !/(^|\s)button(\s|$)/.test(dom.attribs.class) && !/(^|\s)button--block(\s|$)/.test(dom.attribs.class);
}

/**
 * ボタン（インライン）かどうかを判別します。
 *
 * @param {*} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isButton(dom) {
  return dom.type === 'tag' && /^(a|button)$/.test(dom.name) && /(^|\s)button(\s|$)/.test(dom.attribs.class) && !/(^|\s)button--block(\s|$)/.test(dom.attribs.class);
}

//--------------------------------------
//  DOM 操作ヘルパー（その他の要素の判別）
//--------------------------------------

/**
 * DOM 要素が空かどうかを判別します。
 *
 * 空白文字のみで構成されている場合も空と判定します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isEmptyDom(dom) {
  return _.isNil(dom)
  // 空白文字しか含まれてない文字列は空と判定
  // 参照：https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML
  || dom.type === 'text' && /^(&nbsp;|&ensp;|&emsp;|&thinsp;|\s)*$/.test(_.toString(dom.data))
  // タグの場合は属性も子要素も持って無かったら空と判定（br, hr は除外）
  || dom.type === 'tag' && !/^br|hr$/.test(dom.name) && _.isEmpty(dom.attribs) && _.isEmpty(dom.children);
}

/**
 * コメントかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @private
 */
function isComment(dom) {
  return dom.type === 'comment';
}

/**
 * SNS 投稿の埋め込み（TikTok）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isTikTokEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'blockquote' && dom.attribs.class === 'tiktok-embed' && dom.attribs['data-video-id']) {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');

  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var _ref11 = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/) || [],
        _ref12 = _slicedToArray(_ref11, 2),
        embedCode = _ref12[1];
    // 埋め込みタグの中に tiktok-embed の文字列がある場合は TikTok の埋め込み


    return (/tiktok-embed/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（TikTok）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isTikTokEmbedScript(dom) {
  return dom.type === 'script' && dom.attribs.async === '' && /^((http|https):)?\/\/www\.tiktok\.com\/embed\.js$/.test(dom.attribs.src);
}

/**
 * SNS 投稿の埋め込み（Reddit）かどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isRedditEmbed(dom) {
  if (dom.type === 'tag' && dom.name === 'blockquote' && (dom.attribs.class === 'reddit-card' || dom.attribs.class === 'reddit-embed-bq')) {
    return true;
  }

  var iframe = findChildDomByTag(dom, 'iframe');

  if (dom.type === 'tag' && dom.name === 'p' && !_.isNil(iframe)) {
    var _ref13 = _.get(findChildDomByTag(dom, 'iframe'), 'attribs.src').match(/^javascript:\s?'([\s\S]*)?'/) || [],
        _ref14 = _slicedToArray(_ref13, 2),
        embedCode = _ref14[1];
    // 埋め込みタグの中に reddit-card または reddit-embed-bq の文字列がある場合は Reddit の埋め込み


    return (/(reddit-card|reddit-embed-bq)/.test(embedCode)
    );
  }

  return false;
}

/**
 * SNS 投稿の埋め込み（Reddit）スクリプトかどうかを判別します。
 *
 * @param {Object} dom - htmlparser2 の DOM オブジェクト
 * @return {boolean}
 * @private
 */
function isRedditEmbedScript(dom) {
  return dom.type === 'script' && dom.attribs.async === '' && dom.attribs.charset === 'UTF-8' && /^((http|https):)?\/\/embed\.reddit\.com\/widgets\.js$/.test(dom.attribs.src);
}

//------------------------------------------------------------------------------
//
//  Exports
//
//------------------------------------------------------------------------------

module.exports = {

  findChildDomByTag: findChildDomByTag,
  findChildDomsByTag: findChildDomsByTag,

  getText: getText,

  isTable: isTable,

  isArticleInternalLink: isArticleInternalLink,
  isHeading: isHeading,
  isParagraph: isParagraph,
  isList: isList,
  isQuotation: isQuotation,
  isImageBlock: isImageBlock,
  isVideoBlock: isVideoBlock,
  isYouTubeEmbed: isYouTubeEmbed,
  isCgmContentEmbed: isCgmContentEmbed,
  isTwitterTweetEmbed: isTwitterTweetEmbed,
  isTwitterTweetEmbedScript: isTwitterTweetEmbedScript,
  isFacebookEmbed: isFacebookEmbed,
  isFacebookEmbedScript: isFacebookEmbedScript,
  isInstagramEmbed: isInstagramEmbed,
  isInstagramEmbedScript: isInstagramEmbedScript,
  isThreadEmbed: isThreadEmbed,
  isThreadEmbedScript: isThreadEmbedScript,
  isPinterestEmbed: isPinterestEmbed,
  isPinterestEmbedScript: isPinterestEmbedScript,
  isTikTokEmbed: isTikTokEmbed,
  isTikTokEmbedScript: isTikTokEmbedScript,
  isRedditEmbed: isRedditEmbed,
  isRedditEmbedScript: isRedditEmbedScript,
  isBlockButton: isBlockButton,

  isText: isText,
  isLineBreak: isLineBreak,
  isFormatting: isFormatting,
  isLink: isLink,
  isButton: isButton,

  isEmptyDom: isEmptyDom,
  isComment: isComment

};